/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Track_Draw_HintInputs */

const en_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click and drag to create events`)
};

const fr_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez et faites glisser pour creer des evenements`)
};

const de_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken und ziehen Sie, um Ereignisse zu erstellen.`)
};

const it_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai clic e trascina per creare eventi`)
};

const ru_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для создания событий используйте перетаскивание мышью.`)
};

const es_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic y arrastre para crear eventos`)
};

const zh_cn2_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击并拖动即可创建事件`)
};

const ja_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリックしてドラッグしてイベントを作成します`)
};

const hi_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट बनाने के लिए क्लिक करें और ड्रैग करें`)
};

const pt_pt2_timeline_track_draw_hint = /** @type {(inputs: Timeline_Track_Draw_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique e arraste para criar eventos.`)
};

/**
* | output |
* | --- |
* | "Click and drag to create events" |
*
* @param {Timeline_Track_Draw_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_draw_hint = /** @type {((inputs?: Timeline_Track_Draw_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_Draw_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_track_draw_hint(inputs)
	if (locale === "de") return de_timeline_track_draw_hint(inputs)
	if (locale === "it") return it_timeline_track_draw_hint(inputs)
	if (locale === "ru") return ru_timeline_track_draw_hint(inputs)
	if (locale === "es") return es_timeline_track_draw_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_track_draw_hint(inputs)
	if (locale === "ja") return ja_timeline_track_draw_hint(inputs)
	if (locale === "hi") return hi_timeline_track_draw_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_track_draw_hint(inputs)
	return en_timeline_track_draw_hint(inputs)
});